module.exports = __webpack_public_path__ + "img/profesionales.41141ff2.png";